import { addAdditionalAuthData, authorisePaymentCard } from 'common/api/db/functions';
import {
	AdditionalAdminDetailRedirectRequest,
	AdditionalAdminDetailRequest,
	AdyenAdditionalDetailsState,
	AdyenPaymentState,
} from 'common/types';

interface AdyenPaymentParams {
	shopId: string;
	adyenPaymentData: AdyenPaymentState['data'];
	primary?: boolean;
}
export interface AdyenPaymentResult {
	success: boolean;
	error?: string;
	action?: object;
	transactionId: string;
}

export const adyenCardAuth = async ({
	shopId,
	adyenPaymentData,
	primary,
}: AdyenPaymentParams): Promise<AdyenPaymentResult> => {
	const { result, transactionId } = await authorisePaymentCard({
		shopId,
		paymentData: adyenPaymentData,
		browserData: {
			origin: window.location.origin,
			href: window.location.href,
		},
		primary,
	});
	if (!!result.action) {
		return { success: true, action: result.action, transactionId };
	}
	if (result.resultCode === 'Authorised') {
		return { success: true, transactionId };
	}
	return { success: false, error: result.refusalReason ?? 'Payment error', transactionId };
};

type AdyenAdditionalDetailsParams = {
	transactionId: string;
	shopId: string;
	additionalDetailsData: AdyenAdditionalDetailsState['data'] | { redirect: true };
	primary?: boolean;
};

export const adyenAdditionalDetails = async ({
	transactionId: originalTransactionId,
	shopId,
	additionalDetailsData,
	primary,
}: AdyenAdditionalDetailsParams): Promise<AdyenPaymentResult> => {
	const paymentData:
		| AdditionalAdminDetailRedirectRequest
		| AdditionalAdminDetailRequest = isRedirect(additionalDetailsData)
		? {
				transactionId: originalTransactionId,
				redirect: true,
		  }
		: {
				transactionId: originalTransactionId,
				additionalDetails: additionalDetailsData,
		  };
	const { result, transactionId } = await addAdditionalAuthData({
		shopId,
		paymentData,
		primary,
	});
	if (!!result.action) {
		return { success: true, action: result.action, transactionId };
	}
	if (result.resultCode === 'Authorised') {
		return { success: true, transactionId };
	}
	return { success: false, error: result.refusalReason, transactionId };
};

const isRedirect = (
	additionalDetailsData: AdyenAdditionalDetailsState['data'] | { redirect: true },
): additionalDetailsData is { redirect: true } => {
	return !!(additionalDetailsData as { redirect: true }).redirect;
};
